import * as React from "react";
import type { SVGProps } from "react";

const SvgAlarm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.00469 10.9998C5.37969 10.9998 4.79427 10.8811 4.24844 10.6436C3.7026 10.4061 3.2276 10.0852 2.82344 9.68105C2.41927 9.27689 2.09844 8.80189 1.86094 8.25605C1.62344 7.71022 1.50469 7.1248 1.50469 6.4998C1.50469 5.8748 1.62344 5.28939 1.86094 4.74355C2.09844 4.19772 2.41927 3.72272 2.82344 3.31855C3.2276 2.91439 3.7026 2.59355 4.24844 2.35605C4.79427 2.11855 5.37969 1.9998 6.00469 1.9998C6.62969 1.9998 7.2151 2.11855 7.76094 2.35605C8.30677 2.59355 8.78177 2.91439 9.18594 3.31855C9.59011 3.72272 9.91094 4.19772 10.1484 4.74355C10.3859 5.28939 10.5047 5.8748 10.5047 6.4998C10.5047 7.1248 10.3859 7.71022 10.1484 8.25605C9.91094 8.80189 9.59011 9.27689 9.18594 9.68105C8.78177 10.0852 8.30677 10.4061 7.76094 10.6436C7.2151 10.8811 6.62969 10.9998 6.00469 10.9998ZM7.40469 8.5998L8.10469 7.8998L6.50469 6.2998V3.9998H5.50469V6.6998L7.40469 8.5998ZM2.80469 1.1748L3.50469 1.8748L1.37969 3.9998L0.679688 3.2998L2.80469 1.1748ZM9.20469 1.1748L11.3297 3.2998L10.6297 3.9998L8.50469 1.8748L9.20469 1.1748ZM6.00469 9.9998C6.97969 9.9998 7.80677 9.66022 8.48594 8.98105C9.1651 8.30189 9.50469 7.4748 9.50469 6.4998C9.50469 5.5248 9.1651 4.69772 8.48594 4.01855C7.80677 3.33939 6.97969 2.9998 6.00469 2.9998C5.02969 2.9998 4.2026 3.33939 3.52344 4.01855C2.84427 4.69772 2.50469 5.5248 2.50469 6.4998C2.50469 7.4748 2.84427 8.30189 3.52344 8.98105C4.2026 9.66022 5.02969 9.9998 6.00469 9.9998Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgAlarm;
